<!--
    File: Booking.vue
-->

<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12" md="6" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined class="pb-1">
          <v-toolbar class="elevation-0" color="background">
            <v-toolbar-title>
              예약 관리{{studio == 3 ? ' (판교점)' : studio == 6 ? ' (분당점)' : ''}}
            </v-toolbar-title>

            <v-row v-if="login.studio == 3" class="mr-3" justify="end">
                <a v-if="studio == 6" @click="change(3)">판교점</a><span v-if="studio == 3">판교점</span>
                <span class="ml-3 mr-3">|</span>
                <a v-if="studio == 3" @click="change(6)">분당점</a><span v-if="studio == 6">분당점</span>
            </v-row>

          </v-toolbar>
          <v-row justify="center" class="pa-3 mt-1">
            <v-icon class="mr-3" @click="move(-7)">mdi-arrow-left-circle</v-icon>
            <v-toolbar-title>{{schedules[0].date}} ~ {{schedules[5].date}}</v-toolbar-title>
            <v-icon class="ml-3" @click="move(7)">mdi-arrow-right-circle</v-icon>
          </v-row>
          <v-spacer class="pb-3" />
          <v-row class="ma-0">
            <v-col class="pa-0" cols="2" v-for="(day, i) in days" :key="i">
              <div class="text-center title-days">{{day}}</div>

              <v-card class="elevation-0 ml-1 mt-1 pa-1" :color="cellColor(item)" height="90"
                v-for="(item, j) in schedules[i].items" :key="j"
                v-on="item.time ? { click: () => select(item) } : {}"
              >
                <div v-if="item.time">
                  <div class="text-caption font-weight-bold">{{item.time}}</div>
                  <div class="primary--text font-10 font-weight-bold line2">{{item.lesson}}</div>
                  <div class="text-caption color-555 text-truncate">{{item.instructor}}</div>
                  <div v-if="item.booked < item.capacity"
                    :class="$vuetify.breakpoint.smAndDown ? ' font-10 color-33F' : 'text-caption color-33F'">
                    예약 {{item.booked}}명
                  </div>
                  <div v-if="item.booked == item.capacity" :class="'text-caption ' + statusColor(item)">마감</div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div v-if="times.length == 0" class="pa-6 text-center">등록된 수업 스케줄이 없습니다.</div>
        </v-card>
        <div v-if="times.length == 0" class="pt-3 pb-2 text-right">
          <v-btn color="primary" elevation="0" @click="copy()">이전 주 스케줄 복사</v-btn>
        </div>
        <v-spacer class="pa-1" />
      </v-col>
      
      <v-col sm="12" md="6" v-if="schedule" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="elevation-0" color="background">
            <v-toolbar-title class="text-truncate">
              {{schedule.date}} {{schedule.time}} {{schedule.lesson}} ({{schedule.instructor}})
            </v-toolbar-title>
          </v-toolbar>
          
          <v-row v-if="users.length > 0" class="ma-1">
            <v-col cols="5" md="6">예약회원</v-col>
            <v-col cols="5" md="4">{{$vuetify.breakpoint.mdAndUp ? '예약일시' : '휴대폰'}}</v-col>
            <v-col cols="2">예약</v-col>
          </v-row>
          <v-divider v-if="users.length > 0" />

          <div v-if="users.length == 0" class="text-center pa-6 accent--text">예약이 없습니다.</div>

          <v-row class="ma-1" v-for="(user, i) in users" :key="i">
            <v-col cols="5" md="6" class="text-truncate">
              <a @click="setUserInfo(user)" class="black--text">{{user.name}}</a>
              <span class="grey--text ml-3">({{user.email}})</span>
            </v-col>
            <v-col cols="5" md="4" v-if="$vuetify.breakpoint.mdAndUp">{{user.booking_date}}</v-col>
            <v-col cols="5" md="4" class="text-truncate" v-if="$vuetify.breakpoint.smAndDown">
              <a @click="call(user.mobile)">{{util.getPhoneNumber(user.mobile)}}</a>
            </v-col>
            <v-col cols="2"><a @click="unbook(user, schedule)" class="font-weight-bold">취소</a></v-col>
          </v-row>
        </v-card>

        <v-spacer class="pa-3"/>
        <v-row v-if="button">
          <v-col cols="12" class="text-right">
            <v-btn color="primary" elevation="0" @click="button = false">예약자 추가</v-btn>
          </v-col>
        </v-row>

        <v-card outlined v-if="!button">
          <v-row class="pa-3 mb--30" align="center">
            <v-col cols="5"><v-select class="font-14" v-model="type" :items="types" label="회원 찾기" /></v-col>
            <v-col cols="5"><v-text-field class="font-14" v-model="keyword" @keyup.13.stop.prevent="search()" /></v-col>
            <v-col cols="2"><v-icon @click="search()">mdi-magnify</v-icon></v-col>
          </v-row>
          
          <v-divider v-if="found && found.length > 0"/>
          
          <v-row class="ma-1" v-for="(user, i) in found" :key="i">
            <v-col cols="5" md="6" class="text-truncate">
              <a @click="setUserInfo(user)">{{user.name}}</a>
              <span class="grey--text ml-3">{{user.email}}</span>
            </v-col>
            <v-col cols="5" md="4" class="text-truncate">
              <a @click="call(user.mobile)">{{util.getPhoneNumber(user.mobile)}}</a>
            </v-col>
            <v-col cols="2">
              <a v-if="isBookable(user, schedule)" @click="book(user, schedule)">예약</a>
            </v-col>
          </v-row>

          <v-spacer class="pa-1"/>
        </v-card>

      </v-col>
      
      <v-col sm="12" md="6" v-if="user" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-6 elevation-0" color="background">
            <v-toolbar-title>{{user.name}}님의 회원 정보</v-toolbar-title>
          </v-toolbar>

          <v-row class="pl-3 pr-3" v-for="(info, i) in userInfo" :key="i" align-top>
            <v-col cols="1"><v-icon>{{info.icon}}</v-icon></v-col>
            <v-col cols="3">{{info.title}}</v-col>            
            <v-col cols="8">{{info.text}}</v-col>
          </v-row>
          
          <v-spacer class="pa-3"/>
          <v-divider />
          <v-row class="pa-3" align="center" justify="end">
            <v-col class="text-right">
              <v-btn color="primary" elevation="0" @click="getHistory()">예약 이력</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col sm="12" md="6" v-if="history" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-6 elevation-0" color="background">
            <v-toolbar-title>{{title}}</v-toolbar-title>
          </v-toolbar>

          <v-row v-if="history.length > 0" class="pl-3 pb-3">
            <v-col cols="5" md="3">수업일시</v-col>
            <v-col cols="4" md="3" class="text-truncate">수업명</v-col>
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">예약일시</v-col>
            <v-col cols="3" md="2">강사</v-col>
          </v-row>
          <v-divider class="pb-3" v-if="history.length > 0" />

          <div v-if="history.length == 0" class="text-center pb-6 accent--text">예약 이력이 없습니다.</div>

          <v-row class="pl-3" v-for="(info, i) in history.slice(offset, offset + 10)" :key="i" align-top>
            <v-col cols="5" md="3">{{info.date}} {{info.time}}</v-col>
            <v-col cols="4" md="3" class="text-truncate font-weight-light">{{info.lesson}}</v-col>
            <v-col cols="4" v-if="$vuetify.breakpoint.mdAndUp">{{info.booking_date}}</v-col>
            <v-col cols="3" md="2" class="text-truncate font-weight-light">{{info.instructor}}</v-col>
          </v-row>
          
          <v-row v-if="pages == 1" class="pa-3" />
          <v-row v-if="pages >= 2" class="pa-3"><v-divider /></v-row>
          <v-row v-if="pages >= 2" class="ma-3" justify="center">
            <v-pagination circle v-model="page" :length="pages" @input="offset = (page - 1) * 10" />
          </v-row>
        </v-card>
        <v-row v-if="history.length > 0" class="pa-3" align="center">
          <v-col cols="12" class="text-right">{{history.length}}개</v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      login: null,
      days: [ 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT' ],
      times: [],
      schedules: [],
      schedule: null,
      users: [],
      studio: 0,
      levels: [],
      type: '성명',
      types: [
        '성명',
        '아이디',
        '전화번호',
      ],
      button: false,
      keyword: '',
      found: null,
      user: null,
      userInfo: [
        { icon: 'mdi-map-marker', title: '스튜디오', text: '' },
        { icon: 'mdi-wallet-membership', title: '회원구분', text: '' },
        { icon: 'mdi-account', title: '아이디', text: ''},
        { icon: 'mdi-calendar-plus', title: '가입일', text: '' },
        { icon: 'mdi-tag', title: '성명', text: '' },
        { icon: 'mdi-human-male-female', title: '성별', text: '' },
        { icon: 'mdi-cake-variant', title: '생년월일', text: '' },
        { icon: 'mdi-ticket', title: '보유쿠폰', text: '' },
        { icon: 'mdi-cellphone', title: '전화번호', text: '' },
        { icon: 'mdi-home', title: '주소', text: '' },
        { icon: 'mdi-note', title: '메모', text: '' }
      ],
      title: null,
      history:null,
      page: 1,
      pages: 0,
      offset: 0,
      util: util
    }
  },

  methods: {
    move: function (days) {
      for (let i = 0; i < 6; i++) {
        let date = new Date(this.schedules[i].date)
        this.schedules.splice(i, 1, { date: util.getDate(date, days), items: [] })
      }
      this.getSchedule()
    },

    select: function (item) {
      this.schedule = item
      this.history = null
      this.user = null
    //this.button = true
      this.getUsers()
    },

    getHours: function (date, time) {
      let datetime = new Date(date + 'T' + time)
      return (datetime - new Date) / 3600000
    },

    isPast: function (item) {
      return this.getHours(item.date, item.time) < 0
    },

    cellColor: function (item) {
      if (!item.time) return 'white'
      return this.isPast(item) ? 'history' : 'background'
    },

    statusText: function (item) {
      if (item.booked == item.capacity) return '마감'      
      return `예약 ${item.booked}명`
    },

    statusColor: function (item) {
      if (this.isPast(item)) return 'grey--text'
      if (item.booked == item.capacity) return 'red--text'
    },

    getSchedule: function () {
      this.user = null
      this.history = null
      this.schedule = null
      let date1 = this.schedules[0].date
      let date2 = this.schedules[5].date
      axios.get(`/api/booking/list/${this.studio}/${date1}/${date2}`)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {
          this.times.splice(0, this.times.length)
          
          response.data.list.forEach(data => {
            let i = this.schedules.map(schedule => { return schedule.date }).indexOf(data.date)
            if (i >= 0) this.schedules[i].items.unshift(data)
            
            if (this.times.indexOf(data.time) < 0) this.times.push(data.time)
          })
          this.times.sort()

          this.schedules.forEach(schedule => {
            for(let i in this.times) {
              let time = schedule.items.find(item => item.time === this.times[i])
              if (time == null) {
                schedule.items.splice(i, 0, {})
              }
            }
          })
        }
      })
    },
    
    getUsers: function () {
      this.found = null

      axios.get(`api/booking/user/${this.schedule.id}`)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {
          this.users = response.data.list
        }
      })
    },

    search: function () {
      this.found = null
      let type = this.types.indexOf(this.type)
      axios.get(`/api/user/find/${this.login.studio}/?search=${type}&keyword=${this.keyword}`)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.found = response.data.list
        }
      })
    },

    call: function (mobile) {
      location.href = 'tel:' + util.getPhoneNumber(mobile)
    },

    find: function (user, schedule, callback) {
      let query = `/api/booking/find/${user.id}/${schedule.id}`
      axios.get(query)
      .then(response => {
        if (response.data.error) {
          callback(null, response.data.error)
        }
        else if (response.data.schedule) {
          callback(response.data.schedule.booking)
        }
        else {
          callback(null, query)
        }
      })
    },

    isBookable: function (user, schedule) {
      if (this.users.find(x => x.id === user.id)) return false
      if (schedule.booked >= schedule.capacity) return false
      if (user.level < 1) return false
      return true
    },

    book: function (user, schedule) {
      if (!this.isBookable(user, schedule)) {
        alert('예약할 수 없습니다.')
        return
      }
      axios.get(`/api/user/coupon/${user.id}`)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
          alert(`${user.name}님의 쿠폰 정보를 가져올 수 없습니다.`)
          return
        }
        let coupon = response.data.coupon
        if (!coupon || coupon.coupon_type != schedule.coupon_type || coupon.days < 0) {
          alert(`${user.name}님은 사용할 수 있는 쿠폰이 없습니다.`)
          return
        }
        else if (util.getDate(new Date(coupon.expired), 0) < schedule.date) {
          alert('쿠폰 유효기간 내의 수업만 예약하실 수 있습니다.')
          return
        }
        if (coupon.remain < schedule.coupons) {
          alert(`${user.name}님의 쿠폰이 ${schedule.coupons}매 이상 필요합니다.`)
          return
        }
        let info = `날자: ${schedule.date}\n시간: ${schedule.time}\n수업: ${schedule.lesson}\n강사: ${schedule.instructor}`
        let text = `${info}\n\n이 수업을 예약하시겠습니까?\n${user.name}님의 쿠폰 ${schedule.coupons}매가 차감됩니다.`
        if (!confirm(text)) {
          return
        }

        let params = new URLSearchParams()
        params.append('user', user.id)
        params.append('schedule', schedule.id)
        params.append('coupon', coupon.id)
        axios.post('/api/booking/make', params, util.headers)
        .then(response => {
          if (response.data.error) {
            alert(response.data.error)
          }
          else if (response.data.schedule) {
            this.schedule.booked += 1
            this.getUsers()
            alert(`예약되었습니다.`)
          }
          else {
            alert('예약할 수 없습니다.')
          }
        })
      })
    },
    
    unbook: function (user, schedule) {
      let info = `날자: ${schedule.date}\n시간: ${schedule.time}\n수업: ${schedule.lesson}\n강사: ${schedule.instructor}`
      let text = `${info}\n\n이 수업 예약을 취소하시겠습니까?\n${user.name}님의 쿠폰 ${user.coupons}매가 반환됩니다.`
      if (!confirm(text)) {
        return
      }

      this.find(user, schedule, (booking, error) => {
        if (error) {
          alert(error)
          return
        }

        axios.get(`/api/user/coupon/${user.id}`)
        .then(response => {
          if (response.data.error) {
            console.log(response.data.error)
            alert(`${user.name}님의 쿠폰 정보를 가져올 수 없습니다.`)
            return
          }
          let coupon = response.data.coupon
          if (coupon == null) {
            alert(`반환 받을 수 있는 ${user.name}님의 쿠폰이 없습니다.`)
            return
          }

          let params = new URLSearchParams()
          params.append('user', user.id)
          params.append('schedule', schedule.id)
          params.append('coupon', coupon.id)
          axios.post('/api/booking/cancel/' + booking, params, util.headers)
          .then(response => {
            if (response.data.error) {
              alert(response.data.error)
            }
            else if (response.data.result == 'success') {
              this.schedule.booked -= 1
              this.getUsers()
              alert(`${user.name}님의 예약이 취소되었습니다.`)
            }
            else {
              alert(`${user.name}님의 예약을 취소할 수 없습니다.`)
            }
          })
        })
      })
    },

    copy: function () {
      let date1 = util.getDate(new Date(this.schedules[0].date), -7)
      let date2 = util.getDate(new Date(this.schedules[5].date), -7)
      axios.get(`/api/booking/list/${this.studio}/${date1}/${date2}`)
      .then(response => {
        let previous = `이전 주(${date1} ~ ${date2})`
        let schedules = response.data.list
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (schedules && schedules.length) {
          if (confirm(`${previous}의 수업 ${schedules.length}개를 복사하시겠습니까?`)) {
            this.insert(schedules)
          }
        }
        else {
          alert(`${previous}의 수업이 없습니다.`)
        }
      })
    },

    insert: function (schedules) {
      if (schedules.length == 0) {
        this.getSchedule()
        return
      }
      let schedule = schedules.pop()
      let params = new URLSearchParams()
      params.append('date', util.getDate(new Date(schedule.date), 7))
      params.append('time', schedule.time)
      params.append('capacity', schedule.capacity)
      params.append('lesson', schedule.lesson_id)
      params.append('instructor', schedule.instructor_id)
      params.append('memo', schedule.memo ? schedule.memo : '')
      params.append('cancel', schedule.cancel)
      axios.post('/api/schedule/insert/' + this.studio, params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (response.data.schedule) {
          this.insert(schedules)
        }
      })
    },
    
    setUserInfo: function (user) {
      this.user = user
      this.histroy = null
      this.schedule = null
      this.userInfo[0].text = this.login.studio_name
      this.userInfo[1].text = util.getItem(this.levels, user.level).text
      this.userInfo[2].text = user.email
      this.userInfo[3].text = user.cdate.split('T')[0]
      this.userInfo[4].text = user.name + (user.nick ? (' (' + user.nick.replace(/[()]/gi, '') + ')') : '')
      this.userInfo[5].text = user.sex ? (user.sex == 1 ? '남성' : '여성') : '알 수 없음'
      this.userInfo[6].text = user.birth ? user.birth : '알 수 없음'
      util.getUserCoupon(user.id, text => { this.userInfo[7].text = text })
      this.userInfo[8].text = util.getPhoneNumber(user.mobile)
      this.userInfo[9].text =(user.address ? user.address : '') + (user.address2 ? ' ' + user.address2 : '')
      this.userInfo[10].text = user.memo
    },
    
    getHistory: function () {
      let query = `/api/booking/history/${this.user.id}`
      axios.get(query)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          this.title = `${this.user.name} (${this.user.email})님의 예약 이력`
          this.user = null
          this.history = response.data.list
          this.pages = Math.ceil(this.history.length / 10)
          this.page = 1
          this.offset = 0
        }
      })
    },

    change: function (studio) {
      this.studio = studio

      this.schedules.splice(0, this.schedules.length)
      for (let i = 1; i < 7; i++) {
        this.schedules.push({ date: util.getDateOfWeek(new Date, i), items: [] })
      }
      
      this.getSchedule()
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
      this.studio = this.login.studio
    }
    if (this.login == null) {
      this.$router.push('/login')
      return
    }
    else {
      this.$emit('login', this.login)
    }
    for (let i = 1; i < 7; i++) {
      this.schedules.push({ date: util.getDateOfWeek(new Date, i), items: [] })
    }

    util.getLevels((levels, error) => {
      if (error) console.log(error)
      this.levels = levels

      this.getSchedule()
    })
  }
}
</script>

<style scoped>
.mt--20 {
  margin-top: -20px;
}
.mb--30 {
  margin-bottom: -30px;
}
.title-days {
  background: #f4f4f4;
  color: grey;
  padding: 5px;
}
.font-10 {
  font-size: 10px;
}
.font-14 {
  font-size: 14px;
}
.color-33F {
  color: #33F;
}
.color-555 {
  color: #555;
}
.line2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>